module.exports = __webpack_public_path__ + "assets/img/ic-arrow-circle-b.c1da3edd.svg";